import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import AutoBindComponent from "../../common/AutoBindComponent";
import OverzichtPageHelper from "./OverzichtPageHelper";
import * as layoutActions from "../../../actions/layoutActions";
import * as sessionActions from "../../../actions/sessionActions";
import * as securityActions from "../../../actions/securityActions";
import { throwException } from "../../../actions/exceptionActions";
import PropTypes from "prop-types";
import OverzichtOrganisatiesForm from "./OverzichtOrganisatiesForm";
import OverzichtAanvragenForm from "./OverzichtAanvragenForm";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import * as types from "../../../constants/ComponentConstants";
import OverzichtFilterForm from "./OverzichtFilterForm";
import SelectInput from "../../common/SelectInput";
import mergeDeep from "../../../util/mergeDeep";
import redirector from "../../../util/redirector";
import { orderByPropertyName } from "../../../util/orderBy.js";

class OverzichtPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context, true);

		this.state = {
			sportclubModels: [],
			openAanvragenModels: [],
			filter: {
				pageNo: 1,
				pageSize: 20,
				orderBy: "Name",
				ascending: true,
				naam: null,
				locatie: null,
				sporttak: null,
				poId: null,
				telefoonorgsm:null,
				website:null,
				email:null,
				vCode:null,
				ondernemingsnummer: null
			},
			totalPages: 1,
			deteleModalIsOpen: false,
			cancelModalIsOpen: false,
			modalSportclub: null,
			modalTransactie: null,
			exportModalIsOpen: false,
			federatieEmailAdres: null,
			selectedFederatieId: null,
			nameFilterHasFocus: true
		};

		this.pageHelper = new OverzichtPageHelper(this, redirector);
	}

	componentDidMount = () => {
		super.componentDidMount();
		this.props.resetActivatiePopupShown();
		this.pageHelper.loadLayout();
		this.pageHelper.init();
	};

	componentDidUpdate(previousProps) {
		if ((this.props.federaties !== previousProps.federaties) && (this.props.federaties.length && previousProps.federaties.length === 0)) {
			this.pageHelper.init();
		}
	}

	handleOnSortTable = (index) => this.pageHelper.sortTable(index);

	handleOnCopyPoId = (poId, event) => this.pageHelper.copyPoId(poId, event);

	handleEditSportclub = (id, isNew, isReadonly) => this.pageHelper.editSportclub(id, isNew, isReadonly);

	handleOnExportSportclubs = () => this.pageHelper.exportSportclubs();

	handleDeleteSportclub = (id) => this.pageHelper.deleteSportclub(id);

	handleLinkSportclub = (id) => this.pageHelper.linkSportclub(id);

	handleOpenDeleteModal = (sportclub) => this.pageHelper.openDeleteModal(sportclub);

	handleCloseDeleteModal = () => this.pageHelper.closeDeleteModal();

	handleOnSearch = () => this.pageHelper.search();

	handleOnLink = () => this.pageHelper.link();

	handleOnCancelLink = (id) => this.pageHelper.cancelLink(id);

	handleOpenCancelModal = (transactie) => this.pageHelper.openCancelModal(transactie);

	handleCloseCancelModal = () => this.pageHelper.closeCancelModal();

	handleScrollToAanvragen = () => this.pageHelper.scrollToAanvragen();

	handleOpenExportModal = () => this.pageHelper.openExportModal(this.props.federatieEmailAdres);

	handleCloseExportModal = () => this.pageHelper.closeExportModal();

	handleOnChange = (event) => this.pageHelper.change(event);

	handleOnChangePageSize = (pageSize) => this.pageHelper.changePageSize(pageSize);

	isReadyToRender = () => {
		return this.state.model;
	};

	handleOnPageChange = (e, { activePage }) => {
		this.pageHelper.loadSportclubPage(activePage);
	};

	render() {
		const state = this.state;
		const props = this.props;
		const sportclubModels = state.sportclubModels;
		const openAanvragenModels = state.openAanvragenModels;
		const locaties = props.locaties;
		const sporttakken = props.sporttakken;
		const federaties = props.federatiesForList;
		const headerStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlign': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px', 'paddingTop': '7px' };
		const selectStyle = { 'color': '#006fB7', 'fontSize': '32px', 'textAlignLast': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': 'auto', 'backgroundColor': 'white', 'minHeight': '91.2px', 'width': 'auto' };

		return (
			<div>
				<Fragment>
					{props.federaties.length === 1 ?
						<div style={headerStyle}>{props.federaties[0].naam}</div>
						:
						<div style={{ 'backgroundColor': 'white', 'textAlign': 'center' }}>
							<SelectInput defaultItem="Kies je sportorganisatie ......" style={selectStyle} name="selectedFederatieId" value={state.selectedFederatieId} items={federaties} onChange={this.handleOnChange} />
						</div>
					}
					{this.state.selectedFederatieId ?
						<Section
							title={"Beheer aangesloten sportclubs in sportdatabank"}
							color={types.COLOR_BLUE}>
							<Fieldset>
								<OverzichtFilterForm
									filter={state.filter}
									onLink={this.handleOnLink}
									onChange={this.handleOnChange}
									locaties={locaties}
									sporttakken={sporttakken}
									onSearch={this.handleOnSearch}
									onScrollToAanvragen={this.handleScrollToAanvragen}
									exportModalIsOpen={state.exportModalIsOpen}
									onExportSportclubs={this.handleOnExportSportclubs}
									onOpenExportModal={this.handleOpenExportModal}
									onCloseExportModal={this.handleCloseExportModal}
									federatieEmailAdres={state.federatieEmailAdres}
									nameFilterHasFocus={state.nameFilterHasFocus}
									errors={this.state.errors}
								/>
								{sportclubModels ?
									<OverzichtOrganisatiesForm
										sportclubModels={sportclubModels}
										onSortTable={this.handleOnSortTable}
										filter={state.filter}
										totalPages={state.totalPages}
										totalItems={state.totalItems}
										onPageChange={this.handleOnPageChange}
										onEditSportclub={this.handleEditSportclub}
										onCopyPoId={this.handleOnCopyPoId}
										onOpenDeleteModal={this.handleOpenDeleteModal}
										onCloseDeleteModal={this.handleCloseDeleteModal}
										deleteModalIsOpen={state.deleteModalIsOpen}
										modalSportclub={state.modalSportclub}
										onCloseActivateModal={this.handleCloseActivateModal}
										onActivateSportclub={this.handleActivateSportclub}
										onDeleteSportclub={this.handleDeleteSportclub}
										onLinkSportclub={this.handleLinkSportclub}
										onChangePageSize={this.handleOnChangePageSize}
										onCancelLink={this.handleOnCancelLink}
										onOpenCancelModal={this.handleOpenCancelModal}
										foundPoIdBelongsToFederatie={state.foundPoIdBelongsToFederatie}
									/>
									: null}
								{openAanvragenModels && openAanvragenModels.length ?
									<OverzichtAanvragenForm
										openAanvragenModels={openAanvragenModels}
										onCancelLink={this.handleOnCancelLink}
										onEditSportclub={this.handleEditSportclub}
										onOpenDeleteModal={this.handleOpenDeleteModal}
										onCloseDeleteModal={this.handleCloseDeleteModal}
										cancelModalIsOpen={state.cancelModalIsOpen}
										onOpenCancelModal={this.handleOpenCancelModal}
										onCloseCancelModal={this.handleCloseCancelModal}
										modalTransactie={state.modalTransactie}
									/>
									: null}
							</Fieldset>
						</Section> : null}
				</Fragment>
			</div>
		);
	}
}

OverzichtPage.propTypes = {
	federatieId: PropTypes.string,
	federatieNaam: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
	return {
		currentFederatie: state.security.currentOrganisationInfo,
		federatieId: state.security.currentOrganisationInfo.id,
		federatieNaam: state.security.currentOrganisationInfo.naam,
		federatieOndernemingsnummer: state.security.currentOrganisationInfo.ondernemingsnummer,
		emailAdres: state.security.emailAdres,
		federatiesForList: state.security.organisations ? [...state.security.organisations.map(f => mergeDeep({}, { label: f.naam, value: f.id }))] : [],
		federaties: state.security.organisations || [],
		gebruikersnaam: state.security.currentUser,
		locaties: state.referentie.locaties,
		sporttakken: orderByPropertyName(state.referentie.sporttakken.map((s) => mergeDeep({}, s)), "label")
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		loadOverzichtLayout: bindActionCreators(layoutActions.loadOverzichtPageLayout, dispatch),
		setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch),
		throwException: bindActionCreators(throwException, dispatch),
		resetActivatiePopupShown: bindActionCreators(sessionActions.resetActivatiePopupShown, dispatch),
		setUserType: bindActionCreators(sessionActions.setUserType, dispatch),
		setCurrentOrganisation: bindActionCreators(securityActions.setCurrentOrganisation, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(OverzichtPage);
